const _LANGUAGE_TAGS: { [key: string]: [string, boolean] } = {
  PySnip: ["py", false],
  PyHiddenSnip: ["py", true],
};

function html_for_snippet(detected_language: string, code: string) {
  return `
  <div class="snippet">
  <textarea class="snippet_code hl${detected_language}"
    data-lang="${detected_language}">${code}</textarea>
  <div class="snippet_action" data-lang="${detected_language}">
      Click to run ▶</div>
  <div class="snippet_output"></div>
  </div>`;
}

function html_for_hidden_snippet(detected_language: string, code: string) {
  return `
  <div class="snippet">
  <details>
  <summary class="show_code">Click to show code</summary>
  <textarea class="snippet_code hl${detected_language}"
    data-lang="${detected_language}">${code}</textarea>
  <div class="snippet_action" data-lang="${detected_language}">
      Click to run ▶</div>
  </details>
  <div class="snippet_output"></div>
  </div>`;
}

function prepare_textarea_autoheight(elem: HTMLElement) {
  elem.style.height = "auto";
  elem.style.height = Math.max(20, elem.scrollHeight) + "px";
  elem.style.overflowY = "hidden";
}

function set_options_in_data_attrs(html: string, options_str: string) {
  let root = $(`<div>${html}</div>`);
  let div_action = $(root).find(".snippet_action");
  console.log(div_action);
  // abuse div for parsing options_str
  console.log(`Parsing ${options_str}`);
  let attrs = $(`<div ${options_str}></div>`)[0].attributes;
  for (let i = 0; i < attrs.length; i ++) {
    console.log(`${attrs[i].nodeName} <= ${attrs[i].nodeValue}`)
    div_action[0].dataset[attrs[i].nodeName] = attrs[i].nodeValue;
  }
  return root.html();
}

export function transform_snippet_dom() {
  $("pre.highlight").each(function () {
    let detected_language = null;
    let is_hidden = false;
    let options = "";
    for (const tag in _LANGUAGE_TAGS) {
      let match = $(this).html().match(tag + "( (.*)\n)?");
      if (match !== null) {
        detected_language = _LANGUAGE_TAGS[tag][0];
        is_hidden = _LANGUAGE_TAGS[tag][1];
        if (match[2] !== undefined) {
          options = match[2];
        }
      }
    }

    let html: string = "";
    if (detected_language != null) {
      if (is_hidden) {
        html = html_for_hidden_snippet(
          detected_language,
          $(this).text(),
        );
      } else {
        html = html_for_snippet(detected_language, $(this).text());
      }
      html = set_options_in_data_attrs(html, options);
      this.outerHTML = html;
    }
  });
  $("textarea.snippet_code").each(function () {
    prepare_textarea_autoheight(this);
  });
  $("textarea.snippet_code").on("input", function () {
    prepare_textarea_autoheight(this);
  });
  $("summary.show_code").on("click", function () {
    // This is hacky, but for the time being.
    setTimeout(
      () =>
        prepare_textarea_autoheight(
          $(this).parent().find("textarea.snippet_code")[0]
        ),
      100
    );
  });
}
